import { COLORS } from 'consts/colors'
import styled from 'styled-components'

export const SignOutButtonWrapper = styled.div`
  border-top: 1px solid ${COLORS.border};
  width: 100%;
  height: 100%;
`
